module.exports = __webpack_public_path__ + "img/disable-serious.15e18d13.svg";